function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EmberDataPaginatedSerializer from '@square/dashboard-items-data/serializers/ember-data-paginated-serializer';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import { isNone, isEmpty } from '@ember/utils';
import { underscore } from '@ember/string';
export default class PurchaseOrder extends EmberDataPaginatedSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "primaryKey", 'token');
    _defineProperty(this, "collectionKey", 'purchase_orders');
    _defineProperty(this, "rootKey", 'purchase_order');
    _defineProperty(this, "modelName", 'squareup/inventory/v3/purchase-order');
    _defineProperty(this, "attrs", {
      vendor: {
        embedded: 'always'
      }
    });
  }
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);
    if (isNone(json.token)) {
      delete json.token;
    }
    if (isEmpty(json.charge)) {
      delete json.charge;
    }
    return json;
  }
  serializeAttribute(snapshot, json, key, attributes) {
    super.serializeAttribute(snapshot, json, key, attributes);
    if (isNone(snapshot.attr(key))) {
      json[underscore(key)] = snapshot.attr(key);
    }
  }
  normalize(typeClass, hash, prop) {
    // EmberData can't handle pushing an embedded record with no id.
    // We remove the partial vendor here and add it back to the model after loading
    // as a new record.
    if (hash.vendor && !hash.vendor.token) {
      hash.draft_vendor = hash.vendor;
      delete hash.vendor;
    }
    return super.normalize(typeClass, hash, prop);
  }
}